// API service with mock implementation for development
import { TradingSignal, CapeScore, FScore, PnFChart, FinancialData } from './types';

// Expanded S&P 500 tickers list
const mockSP500Tickers = [
  { ticker: 'AAPL', name: 'Apple Inc.' },
  { ticker: 'MSFT', name: 'Microsoft Corporation' },
  { ticker: 'AMZN', name: 'Amazon.com Inc.' },
  { ticker: 'GOOGL', name: 'Alphabet Inc. Class A' },
  { ticker: 'GOOG', name: 'Alphabet Inc. Class C' },
  { ticker: 'META', name: 'Meta Platforms Inc.' },
  { ticker: 'TSLA', name: 'Tesla Inc.' },
  { ticker: 'NVDA', name: 'NVIDIA Corporation' },
  { ticker: 'BRK.B', name: 'Berkshire Hathaway Inc. Class B' },
  { ticker: 'JPM', name: 'JPMorgan Chase & Co.' },
  { ticker: 'JNJ', name: 'Johnson & Johnson' },
  { ticker: 'V', name: 'Visa Inc.' },
  { ticker: 'UNH', name: 'UnitedHealth Group Inc.' },
  { ticker: 'HD', name: 'Home Depot Inc.' },
  { ticker: 'PG', name: 'Procter & Gamble Co.' },
  { ticker: 'XOM', name: 'Exxon Mobil Corporation' },
  { ticker: 'BAC', name: 'Bank of America Corp.' },
  { ticker: 'AVGO', name: 'Broadcom Inc.' },
  { ticker: 'MA', name: 'Mastercard Inc.' },
  { ticker: 'CVX', name: 'Chevron Corporation' },
  { ticker: 'ABBV', name: 'AbbVie Inc.' },
  { ticker: 'LLY', name: 'Eli Lilly and Company' },
  { ticker: 'COST', name: 'Costco Wholesale Corporation' },
  { ticker: 'MRK', name: 'Merck & Co. Inc.' },
  { ticker: 'PEP', name: 'PepsiCo Inc.' },
  { ticker: 'KO', name: 'Coca-Cola Company' },
  { ticker: 'ADBE', name: 'Adobe Inc.' },
  { ticker: 'TMO', name: 'Thermo Fisher Scientific Inc.' },
  { ticker: 'CSCO', name: 'Cisco Systems Inc.' },
  { ticker: 'CRM', name: 'Salesforce Inc.' },
  { ticker: 'MCD', name: 'McDonald\'s Corporation' },
  { ticker: 'ABT', name: 'Abbott Laboratories' },
  { ticker: 'AMD', name: 'Advanced Micro Devices Inc.' },
  { ticker: 'NFLX', name: 'Netflix Inc.' },
  { ticker: 'DIS', name: 'Walt Disney Company' },
  { ticker: 'WMT', name: 'Walmart Inc.' },
  { ticker: 'ACN', name: 'Accenture Plc' },
  { ticker: 'CMCSA', name: 'Comcast Corporation' },
  { ticker: 'PM', name: 'Philip Morris International Inc.' },
  { ticker: 'INTC', name: 'Intel Corporation' },
  { ticker: 'ORCL', name: 'Oracle Corporation' },
  { ticker: 'VZ', name: 'Verizon Communications Inc.' },
  { ticker: 'TMUS', name: 'T-Mobile US Inc.' },
  { ticker: 'WFC', name: 'Wells Fargo & Company' },
  { ticker: 'PFE', name: 'Pfizer Inc.' },
  { ticker: 'TXN', name: 'Texas Instruments Inc.' },
  { ticker: 'DHR', name: 'Danaher Corporation' },
  { ticker: 'LOW', name: 'Lowe\'s Companies Inc.' },
  { ticker: 'UPS', name: 'United Parcel Service Inc.' },
  { ticker: 'IBM', name: 'International Business Machines Corp.' },
  { ticker: 'QCOM', name: 'QUALCOMM Inc.' },
  { ticker: 'BA', name: 'Boeing Company' },
  { ticker: 'CAT', name: 'Caterpillar Inc.' },
  { ticker: 'RTX', name: 'Raytheon Technologies Corp.' },
  { ticker: 'AMAT', name: 'Applied Materials Inc.' },
  { ticker: 'GS', name: 'Goldman Sachs Group Inc.' },
  { ticker: 'SBUX', name: 'Starbucks Corporation' },
  { ticker: 'PYPL', name: 'PayPal Holdings Inc.' },
  { ticker: 'GE', name: 'General Electric Company' },
  { ticker: 'INTU', name: 'Intuit Inc.' },
  { ticker: 'T', name: 'AT&T Inc.' },
  { ticker: 'DE', name: 'Deere & Company' },
  { ticker: 'MS', name: 'Morgan Stanley' },
  { ticker: 'NKE', name: 'Nike Inc.' },
  { ticker: 'AXP', name: 'American Express Company' },
  { ticker: 'HON', name: 'Honeywell International Inc.' },
  { ticker: 'NEE', name: 'NextEra Energy Inc.' },
  { ticker: 'AMGN', name: 'Amgen Inc.' },
  { ticker: 'BMY', name: 'Bristol-Myers Squibb Company' },
  { ticker: 'C', name: 'Citigroup Inc.' },
  { ticker: 'UNP', name: 'Union Pacific Corporation' },
  { ticker: 'BLK', name: 'BlackRock Inc.' },
  { ticker: 'TGT', name: 'Target Corporation' },
  { ticker: 'NOW', name: 'ServiceNow Inc.' },
  { ticker: 'MDLZ', name: 'Mondelez International Inc.' },
  { ticker: 'ISRG', name: 'Intuitive Surgical Inc.' },
  { ticker: 'SPGI', name: 'S&P Global Inc.' },
  { ticker: 'BKNG', name: 'Booking Holdings Inc.' },
  { ticker: 'MMM', name: '3M Company' },
  { ticker: 'GILD', name: 'Gilead Sciences Inc.' },
  { ticker: 'ADI', name: 'Analog Devices Inc.' },
  { ticker: 'SCHW', name: 'Charles Schwab Corporation' },
  { ticker: 'PLD', name: 'Prologis Inc.' },
  { ticker: 'LMT', name: 'Lockheed Martin Corporation' },
  { ticker: 'ABNB', name: 'Airbnb Inc.' },
  { ticker: 'SYK', name: 'Stryker Corporation' },
  { ticker: 'AMT', name: 'American Tower Corporation' },
  { ticker: 'MO', name: 'Altria Group Inc.' },
  { ticker: 'ADP', name: 'Automatic Data Processing Inc.' },
  { ticker: 'LRCX', name: 'Lam Research Corporation' },
  { ticker: 'REGN', name: 'Regeneron Pharmaceuticals Inc.' },
  { ticker: 'MRNA', name: 'Moderna Inc.' },
  { ticker: 'MDT', name: 'Medtronic Plc' },
  { ticker: 'DASH', name: 'DoorDash Inc.' },
  { ticker: 'COP', name: 'ConocoPhillips' },
  { ticker: 'ZTS', name: 'Zoetis Inc.' },
  { ticker: 'TJX', name: 'TJX Companies Inc.' },
  { ticker: 'CVS', name: 'CVS Health Corporation' },
  { ticker: 'EMR', name: 'Emerson Electric Co.' },
  { ticker: 'LYFT', name: 'Lyft Inc.' },
  { ticker: 'SQ', name: 'Block Inc.' },
  { ticker: 'UBER', name: 'Uber Technologies Inc.' }
];

// Function to generate mock trading signals for all S&P 500 tickers
const generateMockSignals = () => {
  const signals: TradingSignal[] = [];
  
  // Define distributions for the different signals
  const buyPercentage = 0.35;  // 35% buy signals
  const sellPercentage = 0.25; // 25% sell signals
  // remaining 40% will be hold signals
  
  mockSP500Tickers.forEach((stock, index) => {
    const ticker = stock.ticker;
    
    // Generate a random F-Score between 1 and 9
    const fScore = Math.floor(Math.random() * 9) + 1;
    
    // Generate CAPE value (lower is better)
    // Range 15-50 with most values in the 20-35 range
    const cape = 15 + Math.random() * 35;
    const capePercentile = cape / 50 * 100; // Convert to percentile
    
    // Decide signal type based on index and our distribution
    let finalSignal: 'Buy' | 'Sell' | 'Hold';
    let preliminarySignal: 'Buy' | 'Sell' | 'Hold';
    
    if (index < mockSP500Tickers.length * buyPercentage) {
      finalSignal = 'Buy';
      // For buy signals, we want lower CAPE and higher F-Score
      preliminarySignal = fScore >= 7 ? 'Buy' : 'Hold';
    } else if (index < mockSP500Tickers.length * (buyPercentage + sellPercentage)) {
      finalSignal = 'Sell';
      // For sell signals, we want higher CAPE and lower F-Score
      preliminarySignal = fScore <= 4 ? 'Sell' : 'Hold';
    } else {
      finalSignal = 'Hold';
      preliminarySignal = 'Hold';
    }
    
    // Create F-Score details based on the numeric score
    const fScoreDetails: FScore = {
      ticker,
      score: fScore,
      roa: fScore > 2, // Return on Assets is positive
      cfo: fScore > 1, // Cash Flow from Operations is positive
      deltaRoa: fScore > 6, // ROA is higher than previous year
      accrual: Math.random() > 0.3, // Accrual is lower than previous year
      deltaLeverage: fScore > 5, // Leverage ratio is lower than previous year
      deltaLiquidity: fScore > 4, // Current ratio is higher than previous year
      noEquityRaise: Math.random() > 0.4, // No new shares were issued
      deltaMargin: fScore > 7, // Gross margin is higher than previous year
      deltaTurnover: fScore > 3 // Asset turnover ratio is higher than previous year
    };
    
    // Create the trading signal
    signals.push({
      ticker,
      cape,
      capePercentile,
      f_score: fScore,
      preliminarySignal,
      finalSignal,
      date: new Date().toISOString().split('T')[0],
      fScore: fScoreDetails
    });
  });
  
  return signals;
};

// Generate mock trading signals for all S&P 500 stocks
const mockTradingSignals = generateMockSignals();

// Mock stock analysis data for the first few companies
const mockStockAnalysis = {
  AAPL: {
    capeScore: {
      cape: 30.5,
      capePercentile: 0.85,
      date: new Date().toISOString().split('T')[0]
    } as CapeScore,
    fScore: {
      ticker: 'AAPL',
      score: 8,
      roa: true,
      cfo: true,
      deltaRoa: true,
      accrual: true,
      deltaLeverage: true,
      deltaLiquidity: true,
      noEquityRaise: true,
      deltaMargin: false,
      deltaTurnover: true
    } as FScore,
    pnfChart: {
      ticker: 'AAPL',
      columns: [
        { direction: 'up', boxes: [170, 171, 172, 173, 174, 175], high: 175, low: 170 }
      ],
      patterns: {
        tripleTopBreakout: true,
        tripleTopBreakdown: false,
        quadTopBreakout: false,
        quadTopBreakdown: false
      },
      currentPrice: 175.80
    } as PnFChart,
    financialData: {
      ticker: 'AAPL',
      priceHistory: Array.from({ length: 30 }, (_, i) => ({
        date: new Date(Date.now() - i * 24 * 60 * 60 * 1000).toISOString().split('T')[0],
        open: 175 + Math.random() * 5,
        high: 180 + Math.random() * 5,
        low: 170 + Math.random() * 5,
        close: 176 + Math.random() * 4,
        volume: 70000000 + Math.random() * 10000000
      })),
      incomeStatement: [
        { 
          date: '2023-01-01', 
          totalRevenue: 394328000000, 
          grossProfit: 173973000000, 
          netIncome: 96995000000,
          eps: 6.14
        },
        { 
          date: '2022-01-01', 
          totalRevenue: 394328000000, 
          grossProfit: 170782000000, 
          netIncome: 99803000000,
          eps: 6.11
        },
        { 
          date: '2021-01-01', 
          totalRevenue: 365817000000, 
          grossProfit: 152836000000, 
          netIncome: 94680000000,
          eps: 5.61
        }
      ],
      balanceSheet: [],
      cashFlow: []
    } as FinancialData
  },
  MSFT: {
    capeScore: {
      cape: 28.7,
      capePercentile: 0.78,
      date: new Date().toISOString().split('T')[0]
    } as CapeScore,
    fScore: {
      ticker: 'MSFT',
      score: 7,
      roa: true,
      cfo: true,
      deltaRoa: false,
      accrual: true,
      deltaLeverage: true,
      deltaLiquidity: true,
      noEquityRaise: true,
      deltaMargin: true,
      deltaTurnover: false
    } as FScore,
    pnfChart: {
      ticker: 'MSFT',
      columns: [
        { direction: 'up', boxes: [310, 311, 312, 313, 314, 315], high: 315, low: 310 }
      ],
      patterns: {
        tripleTopBreakout: false,
        tripleTopBreakdown: false,
        quadTopBreakout: true,
        quadTopBreakdown: false
      },
      currentPrice: 315.75
    } as PnFChart,
    financialData: {
      ticker: 'MSFT',
      priceHistory: Array.from({ length: 30 }, (_, i) => ({
        date: new Date(Date.now() - i * 24 * 60 * 60 * 1000).toISOString().split('T')[0],
        open: 310 + Math.random() * 5,
        high: 320 + Math.random() * 5,
        low: 305 + Math.random() * 5,
        close: 315 + Math.random() * 4,
        volume: 30000000 + Math.random() * 5000000
      })),
      incomeStatement: [
        { 
          date: '2023-01-01', 
          totalRevenue: 211915000000, 
          grossProfit: 147060000000, 
          netIncome: 72361000000,
          eps: 9.68
        },
        { 
          date: '2022-01-01', 
          totalRevenue: 198270000000, 
          grossProfit: 135620000000, 
          netIncome: 67450000000,
          eps: 8.94
        },
        { 
          date: '2021-01-01', 
          totalRevenue: 168088000000, 
          grossProfit: 115856000000, 
          netIncome: 61271000000,
          eps: 8.05
        }
      ],
      balanceSheet: [],
      cashFlow: []
    } as FinancialData
  }
};

// Default stock data for any ticker not in our mock data
const defaultStockAnalysis = {
  capeScore: {
    cape: 25.0,
    capePercentile: 0.5,
    date: new Date().toISOString().split('T')[0]
  } as CapeScore,
  fScore: {
    ticker: '',
    score: 5,
    roa: true,
    cfo: true,
    deltaRoa: false,
    accrual: true,
    deltaLeverage: false,
    deltaLiquidity: false,
    noEquityRaise: true,
    deltaMargin: false,
    deltaTurnover: true
  } as FScore,
  pnfChart: {
    ticker: '',
    columns: [
      { direction: 'up', boxes: [100, 101, 102, 103], high: 103, low: 100 }
    ],
    patterns: {
      tripleTopBreakout: false,
      tripleTopBreakdown: false,
      quadTopBreakout: false,
      quadTopBreakdown: false
    },
    currentPrice: 100.00
  } as PnFChart,
  financialData: {
    ticker: '',
    priceHistory: Array.from({ length: 30 }, (_, i) => ({
      date: new Date(Date.now() - i * 24 * 60 * 60 * 1000).toISOString().split('T')[0],
      open: 100 + Math.random() * 5,
      high: 105 + Math.random() * 5,
      low: 95 + Math.random() * 5,
      close: 101 + Math.random() * 4,
      volume: 10000000 + Math.random() * 5000000
    })),
    incomeStatement: [
      { 
        date: '2023-01-01', 
        totalRevenue: 100000000, 
        grossProfit: 70000000, 
        netIncome: 30000000,
        eps: 3.00
      },
      { 
        date: '2022-01-01', 
        totalRevenue: 95000000, 
        grossProfit: 65000000, 
        netIncome: 28000000,
        eps: 2.80
      },
      { 
        date: '2021-01-01', 
        totalRevenue: 90000000, 
        grossProfit: 60000000, 
        netIncome: 25000000,
        eps: 2.50
      }
    ],
    balanceSheet: [],
    cashFlow: []
  } as FinancialData
};

// Generate mock price data for all S&P 500 tickers
const generateMockPrices = () => {
  const prices: Record<string, number> = {};
  
  mockSP500Tickers.forEach(stock => {
    // Generate a realistic stock price (most between $50-$500)
    const basePrice = 50 + Math.random() * 450;
    prices[stock.ticker] = parseFloat(basePrice.toFixed(2));
  });
  
  // Add some well-known specific prices
  prices['AAPL'] = 175.80;
  prices['MSFT'] = 315.75;
  prices['AMZN'] = 147.42;
  prices['GOOGL'] = 131.86;
  prices['META'] = 325.11;
  prices['TSLA'] = 251.05;
  prices['NVDA'] = 487.15;
  prices['JPM'] = 183.99;
  prices['V'] = 269.04;
  prices['PG'] = 162.53;
  
  return prices;
};

// Mock price data for portfolios
const mockPrices = generateMockPrices();

// API Service interface
interface ApiService {
  runStrategy: (params: { ticker: string }) => Promise<TradingSignal[]>;
  getTradingSignals: (forceRefresh?: boolean) => Promise<TradingSignal[]>;
  getSP500Tickers: () => Promise<Array<{ ticker: string; name: string }>>;
  getStockAnalysis: (ticker: string) => Promise<{
    capeScore: CapeScore;
    fScore: FScore;
    pnfChart: PnFChart;
    financialData: FinancialData;
  }>;
  getCurrentPrice: (ticker: string) => Promise<number>;
  getPortfolioPositions: () => Promise<any[]>;
  addPosition: (position: any) => Promise<any>;
  updatePosition: (id: string, position: any) => Promise<any>;
  removePosition: (id: string) => Promise<void>;
  updateCashBalance: (balance: number) => Promise<number>;
  getPortfolio: () => Promise<any>;
  refreshPositionPrices: () => Promise<any[]>;
}

// Implementation with mock data for now
export const apiService: ApiService = {
  runStrategy: async (params) => {
    // Simulate API call delay
    await new Promise(resolve => setTimeout(resolve, 1000));
    return mockTradingSignals;
  },
  
  getTradingSignals: async () => {
    // Simulate API call delay
    await new Promise(resolve => setTimeout(resolve, 1000));
    return mockTradingSignals;
  },
  
  getSP500Tickers: async () => {
    // Simulate API call delay
    await new Promise(resolve => setTimeout(resolve, 1000));
    return mockSP500Tickers;
  },
  
  getStockAnalysis: async (ticker) => {
    // Simulate API call delay
    await new Promise(resolve => setTimeout(resolve, 1000));
    
    // Return mock data for the requested ticker, or default if not found
    const analysis = mockStockAnalysis[ticker as keyof typeof mockStockAnalysis] || {
      ...defaultStockAnalysis,
      financialData: {
        ...defaultStockAnalysis.financialData,
        ticker
      },
      fScore: {
        ...defaultStockAnalysis.fScore,
        ticker
      },
      pnfChart: {
        ...defaultStockAnalysis.pnfChart,
        ticker
      }
    };
    
    return analysis;
  },
  
  getCurrentPrice: async (ticker) => {
    // Simulate API call delay
    await new Promise(resolve => setTimeout(resolve, 500));
    return mockPrices[ticker] || 100.0;
  },
  
  // Portfolio methods
  getPortfolioPositions: async () => {
    await new Promise(resolve => setTimeout(resolve, 500));
    return [];
  },
  
  addPosition: async (position) => {
    await new Promise(resolve => setTimeout(resolve, 500));
    return {
      id: Date.now().toString(),
      ...position,
      created_at: new Date().toISOString()
    };
  },
  
  updatePosition: async (id, position) => {
    await new Promise(resolve => setTimeout(resolve, 500));
    return {
      ...position,
      updated_at: new Date().toISOString()
    };
  },
  
  removePosition: async (id) => {
    await new Promise(resolve => setTimeout(resolve, 500));
  },
  
  updateCashBalance: async (balance) => {
    await new Promise(resolve => setTimeout(resolve, 500));
    return balance;
  },
  
  getPortfolio: async () => {
    await new Promise(resolve => setTimeout(resolve, 500));
    return {
      cash_balance: 100000,
      positions: []
    };
  },
  
  refreshPositionPrices: async () => {
    await new Promise(resolve => setTimeout(resolve, 500));
    return [];
  }
}; 